import styled from 'styled-components'

export const MobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 14px 18px 14px;
  background-color: ${({ theme }) => theme.colors.grayLighter};
  box-shadow: 0 1px 1px ${({ theme }) => theme.shadow.black12};
  ${({ expandedSB, landingSearchBox }) =>
    !landingSearchBox &&
    expandedSB &&
    `
    position: absolute;
    top: 190px;
    right: 0;
    left: 0;
    z-index: 10;
  `};
`

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Title = styled.label`
  font-size: 18px;
  color: ${({ theme }) => theme.colors.blue};
  font-family: ${({ theme }) => theme.fonts.semiBold};
  text-align: left;
  margin-top: 4px;
`

export const TextContainer = styled.div`
  display: flex;
  font-size: 14px;
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.doveGray};
`

export const TextOriginDest = styled.span`
  color: ${({ theme }) => theme.colors.blue};
  font-family: ${({ theme }) => theme.fonts.semiBold};
  text-transform: uppercase;
  font-size: ${({ fontSize }) => `${fontSize}px`};
`

export const WrapperPadding = styled.span`
  padding: 0 10px;
`

export const DateWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const DateTextWrapper = styled.span`
  padding-left: 5px;
`

export const Wrapper = styled.div``

export const Separator = styled.div`
  border-bottom: 1px dashed ${({ theme }) => theme.colors.gray60};
  margin: 4px 0 7px;
  ${({ expandedSB }) => (expandedSB ? `margin: 18px 0 7px` : `display: none`)};
`

export const LoaderWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 30px 20px 0;
`
